import { render, staticRenderFns } from "./Offerwall.vue?vue&type=template&id=53eb8dbe&scoped=true&"
import script from "./Offerwall.vue?vue&type=script&lang=js&"
export * from "./Offerwall.vue?vue&type=script&lang=js&"
import style0 from "./Offerwall.vue?vue&type=style&index=0&id=53eb8dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eb8dbe",
  null
  
)

export default component.exports